import { render } from "./Recycler.vue?vue&type=template&id=807a0176"
import script from "./Recycler.vue?vue&type=script&lang=js"
export * from "./Recycler.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__